import { useContext } from "react";
import { SocketContext } from "../context/socket-v1";

export const useSocket = () => {
  const socket = useContext(SocketContext);

  return socket;
};